import React from "react";
import "./Why_Majestry.css";

const WhyMajesty = () => {
  return (
    <section className="why_majestry_section">
      <div className="container">
        <div className="majestry_container">
          <div className="majestry_content">
            <h2 className="majestry_title">Why Majesty?</h2>
            <p className="majestry_text">
              We don’t just make beds; we design sleep systems. Every Majesty
              product is a result of years of research into human ergonomics &
              material durability. We realized that the "one-size-fits-all"
              approach to mattresses was failing sleepers, so we set out to
              create a range that adapts to the individual.
            </p>
          </div>

          <div className="majestry_image_wrapper">
            <img
              src="/assets/images/about-us/why_majestry.png"
              alt="Majesty Mattress Production"
              className="majestry_image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyMajesty;
